import { render, staticRenderFns } from "./DataSyncStatusBanner.vue?vue&type=template&id=1caee89c"
import script from "./DataSyncStatusBanner.vue?vue&type=script&lang=ts"
export * from "./DataSyncStatusBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports